import { JobBudget } from './job.budget';
import { SupervisorEntity } from '../contact';
import { Entity, EntityLink, SearchableEntity } from '../entity';
import { JobMode } from '../enums';
import { Activity, Address, Attachment, Site, SiteTiny } from '../shared';
import { InvoiceTiny } from './finance';
import { PriorityTiny } from './priority.tiny';
import { SystemWorkOrderStatus } from './system.workorder.status';
import { WorkFile } from './work.file';
import { WorkOrder, WorkOrderWithTechnician } from './workorder';
import { JobPolicyThresholds } from '../policies';
export interface TinyWorkOrder {
    status: string;
    technician: Entity;
}

export interface JobSummary {
    _id: string;
    jobNumber: string;
    jobName: string;
    dueDate: Date;
    createdDate?: Date;
    startDate?: Date;
    completedDate?: Date;
    priority: Entity;
    address: Address;
    customer: Entity;
    priceBook?: Entity;
    priceBookId: string;
    jobType?: Entity;
    jobTypeId: string;
    status: string;
    owner?: Entity;
    workOrders?: TinyWorkOrder[];
    completed?: number;
    technician?: Entity;
    jobStartDate?: Date;
    jobDueDate?: Date;
    labels?: Entity[];
}

export interface JobListView {
    _id: string;
    jobNumber: string;
    dueDate: Date;
    createdAt?: Date;
    updatedAt?: Date;
    startDate?: Date;
    priority: Entity;
    jobType?: Entity;
    priceBook?: Entity;
    contactPhone: String;
    contactName: String;
    address: Address;
    customer: Entity;
    status: String;
    workOrderCount: number;
    completed?: number;
    owner?: Entity;
    labels?: Entity[],
    customerWO?: String,
    billingCompany?: Entity;
}

export interface JobWithWorkOrdersView extends JobListView {
    workOrders?: WorkOrderWithTechnician[];
}

export interface ChildJob {
    _id: string;
    jobNumber?: string;
    dueDate?: Date;
    note?: string;
}

export interface JobDateSort {
    asc: Date;
    desc: Date;
}

export interface JobSorting {
    dueDate: JobDateSort;
    completedDate: JobDateSort;
    priority: number;
}


export interface Job extends SearchableEntity {

    // tenantId?: string;
    mode: JobMode;
    createdBy: Entity;
    createdAt?: Date;
    updatedAt?: Date;
    imported?: boolean;
    status?: SystemWorkOrderStatus;
    source?: JobSource;

    jobNumber: string;
    startDate?: Date;
    dueDate: Date;
    completedDate?: Date;
    completedNote?: string;
    invoice?: InvoiceTiny;
    invoices?: string[];

    name?: string;
    description: string;
    customer?: Entity;
    customerPO?: string;
    customerWO?: string;
    owner?: Entity;
    fieldSupervisor?: Entity;
    pricebook?: Entity;
    billingCompany?: Entity;
    site?: SiteTiny;

    attachments?: Attachment[];

    priority?: PriorityTiny;
    type?: Entity;

    supervisor?: SupervisorEntity;
    workOrders?: WorkOrder[];
    workFiles?: WorkFile[];

    buyPrice?: number;
    sellPrice?: number;

    quoteId?: string;
    quoteNumber?: string;

    additionalNote?: string;
    finalisedDate?: Date;
    finalisedNote?: string;
    labels?: Entity[];

    sorting?: JobSorting;
    customFields?: any;
    zones?: Entity[];
    integrationId?: string;
    defectCount?: number;

    connectToken?: string; // used to store the workbuddy connect token.
    recurringJob?: Entity;
    recurrenceDate?: Date;
    template?: Entity;

    budget?: JobBudget;

    opportunity?: Entity;
    quote?: Entity;

    firstDispatchDate?: Date;

    agreement?: Entity;
    policy?: Entity;
    thresholds?: JobPolicyThresholds;
    workorderDispatchTheme?: Entity;

    claimToken?: string;
    systemLabels?: Entity[];

    links?: EntityLink[];

    idempotentKey?: string;

    integrationFields?: any;
}


export interface ArchiveJob extends Job {
    archive: boolean;
    activity?: Activity;
}

export enum JobSource {
    Active = 'jobs',
    Closed = 'closed',
    Archive = 'archive',
    Export = 'export',
    Manually = 'manually',
    Imported = 'imported',
    Recurring = 'recurring',
    BulkImport = 'bulkImport',
}

export enum JobCommandIds {
    GetJobAddresses = 'GetJobAddress',
}

export type JobCommandRequest =
    {
        commandId: JobCommandIds.GetJobAddresses,
        data: {
            id: string;
        }
    };
